module.exports = __webpack_public_path__ + "img/yx1.83cf94f6.png";